import React from "react";
import DragHandleIcon from "@material-ui/icons/DragHandle";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";

const IndicatorRenderer = ({ value }) => {
    if (value === undefined || value === null) return null;
    const number = Number(value);
    if (number === 0) return <DragHandleIcon style={{ fill: "var(--ownBlue)" }} />
    if (number > 0) return <ArrowUpwardIcon style={{ fill: "var(--ownGreen)" }} />
    return <ArrowDownwardIcon style={{ fill: "var(--ownRed)" }} />
}

export default IndicatorRenderer;